export abstract class Service {
	constructor() { }
}
